import ServiceOrder from "../../../../../../dto/ServiceOrder"

export enum ActionType {
    ORDER_LOADING = 'ORDER_LOADING',
    ORDER_DATA = 'ORDER_DATA',
    ORDER_ERROR = 'ORDER_ERROR'
}

export interface ActionOrders {
    type: ActionType.ORDER_DATA,
    list: ServiceOrder[]
}

export interface ActionOrdersFetchError {
    type: ActionType.ORDER_ERROR,
    message: String
}


type Action = ActionOrders | ActionOrdersFetchError

export default Action